import * as React from "react";

interface Compass {
  angle: number;
  style: any;
}

const Compass = (props: Compass) => {
    return (
        <div style={{ height: 22, width: 22, ...props.style }}>
            <svg style={{ transform: `rotate(${props.angle})` }} width="20" height="26" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.038 3L9 10H11L10.038 3Z" fill="white" />
                <path d="M10 19.5C15.2467 19.5 19.5 15.2467 19.5 10C19.5 4.75329 15.2467 0.5 10 0.5C4.75329 0.5 0.5 4.75329 0.5 10C0.5 15.2467 4.75329 19.5 10 19.5Z" stroke="white" strokeMiterlimit="10" />
            </svg>
        </div>        
  );
};

export default Compass;
